export default __webpack_public_path__ + "static/media/video.63e69dc2.svg";